import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 拼箱Addon运价维护-列表查询
export function queryPriceLclAddon(data) {
  return request({
    url: URL.price.priceLclAddon.queryPriceLclAddon,
    method: 'post',
    data
  })
}
// 拼箱Addon运价维护-保存
export function savePriceLclAddon(data) {
  return request({
    url: URL.price.priceLclAddon.savePriceLclAddon,
    method: 'post',
    data
  })
}
// 拼箱Addon运价维护-批量删除
export function deletePriceLclAddons(data) {
  return request({
    url: URL.price.priceLclAddon.deletePriceLclAddons,
    method: 'post',
    data
  })
}
// 拼箱Addon运价维护-批量审核
export function approvePriceLclAddons(data, params) {
  return request({
    url: URL.price.priceLclAddon.approvePriceLclAddons,
    method: 'post',
    data,
    params
  })
}
